import React, { PropsWithChildren } from 'react';
import useOnline from '@rooks/use-online';
import { OfflineError } from '../components/error-pages/OfflineError';

export function ErrorWrapper(props: PropsWithChildren<{}>) {
  const { children } = props;
  const isOnline = useOnline();
  return <>{isOnline ? children : <OfflineError />}</>;
}
